import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=18422bb6&scoped=true&"
import script from "./MessageBox.vue?vue&type=script&lang=ts&"
export * from "./MessageBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18422bb6",
  null
  
)

export default component.exports